// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Header {
  z-index: 1000;
  width: 100vw;
  height: 80px;
  flex-shrink: 0;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #5e6786;
  background: #414855;
  box-shadow: 0px 8px 10px 0px rgba(0, 0, 0, 0.1), 0px 6px 30px 0px rgba(0, 0, 0, 0.06), 0px 16px 24px 0px rgba(0, 0, 0, 0.07);
}
.Header .nav {
  display: inline-flex;
  align-items: center;
  padding-left: 0px;
}
.Header .nav .logo {
  margin-right: 40px;
  width: 145.424px;
  height: 70px;
  flex-shrink: 0;
  margin-left: 7px;
}
.Header .nav .logo-emsl {
  width: 150px;
  height: 200px;
  flex-shrink: 0;
  margin-bottom: -30px;
}
.Header .button-group {
  display: flex;
  gap: 16px;
  align-items: center;
  padding-right: 100px;
}
.Header .button-group .user-name {
  display: flex;
  padding: 9px 16px 9px 0px;
  justify-content: center;
  align-items: center;
  gap: 8px;
}
.Header .scientia-platform {
  background: #272931;
}
.dropdown {
  display: flex;
  padding: 2px 5px 2px 5px;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  border-radius: 10px;
}
.dropdown :hover {
  background-color: var(--primary-color-hover-low-opacity, rgba(160, 226, 255, 0.15));
}
.dropdown-overlay-style {
  color: #66d1ff;
  border-radius: 4px;
  border: 2px solid var(--Primary-Color-Default, #66D1FF);
  background: var(--Surface-0-dp, #2E313A);
  /* 4 dp */
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.07), 0px 4px 5px 0px rgba(0, 0, 0, 0.06), 0px 1px 10px 0px rgba(0, 0, 0, 0.1);
}
.hamburger-menu-items {
  display: block;
  cursor: pointer;
}
@media screen and (min-width: 1315px) {
  .hamburger-menu-items {
    display: none;
  }
}
.separator-bar {
  transform: scale(0.1, 1);
  color: white;
  font-size: 50px;
}
.modal-text-style {
  font-family: "Open Sans";
  font-style: normal;
  line-height: normal;
  color: #CCCCCC !important;
  font-weight: 400;
}
.content-style {
  display: flex;
  width: 600px;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 450px;
}
.content-style .text-box-style {
  display: flex;
  padding: 9px 16px;
  align-items: flex-start;
  gap: 8px;
  flex: 1 0;
  align-self: stretch;
  width: 565px !important;
  background-color: #272931;
  border-radius: 4px;
  margin-top: -16px;
  color: #CCCCCC;
}
.content-style .import-files {
  border-radius: 4px;
  border: 2px dashed;
  border-color: #66d1ff;
  display: flex;
  height: 64px;
  width: 580px;
  padding: 8px;
  justify-content: center;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  margin-top: 8px;
}
.content-style .file-input {
  display: none;
}
.content-style .file-list {
  margin-top: 16px;
}
.content-style .delete-button {
  background-color: #FF4D4F;
  color: white;
  border: none;
  border-radius: 50%;
  padding: 4px 8px;
  cursor: pointer;
}
.content-style .delete-button :hover {
  background-color: #ff7875;
}
.content-style .file-item {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}
.content-style .file-item p {
  margin: 0;
}
.modalForm {
  display: flex;
  width: 100vw !important;
  height: 980px;
  padding: 100px;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  background: rgba(51, 51, 51, 0.6);
  border-radius: 4px;
  box-shadow: 0px 16px 24px 0px rgba(0, 0, 0, 0.07), 0px 6px 30px 0px rgba(0, 0, 0, 0.06), 0px 8px 10px 0px rgba(0, 0, 0, 0.1);
}
.modalForm .ant-modal-content {
  background-color: #414855;
  width: 680px;
  height: 690px;
  padding: 40px 40px 32px 40px;
  overflow-y: auto;
  display: inline-table;
}
.select-feedback-dropdown {
  margin-top: -16px;
}
.select-feedback-dropdown .ant-select-selector {
  background-color: #2E313A !important;
  color: white;
  border-color: rgba(51, 51, 51, 0.6) !important;
  box-shadow: none !important;
}
.select-feedback-dropdown .ant-select-selector:hover {
  border-radius: 4px;
  border: 2px solid var(--Primary-Color-Default, #66D1FF) !important;
  background: var(--Surface-0-dp, #2E313A);
  /* 4 dp */
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.07), 0px 4px 5px 0px rgba(0, 0, 0, 0.06), 0px 1px 10px 0px rgba(0, 0, 0, 0.1);
}
.select-feedback-dropdown .ant-select-arrow {
  color: white !important;
}
.dropdown-popup {
  background-color: #2E313A !important;
  border-radius: 4px;
  border: 2px solid var(--Primary-Color-Default, #66D1FF) !important;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.07), 0px 4px 5px 0px rgba(0, 0, 0, 0.06), 0px 1px 10px 0px rgba(0, 0, 0, 0.1);
}
.select-option-group-text {
  color: var(--Content-Color-Low-Priority, #BABABA);
  /* Caption */
  font-family: "Open Sans";
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.select-text-style {
  font-family: "Open Sans";
  font-style: normal;
  line-height: normal;
  color: #CCCCCC;
  font-weight: 400;
}
.ant-select-item:hover {
  background-color: var(--primary-color-hover-low-opacity, rgba(160, 226, 255, 0.15)) !important;
}
.ant-select-item-option-selected {
  background-color: var(--primary-color-active-low-opacity, #66d1ff26) !important;
  color: red !important;
}
.ant-select-item-option-active {
  color: red;
  background-color: pink;
}
.feedback-received-modal {
  display: flex;
  width: 620px;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
}
.feedback-received-modal .h2 {
  color: var(--Content-Color-High-Priority, #FFF);
  /* H2 */
  font-family: "Open Sans";
  font-size: 32px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  margin: 0px 0px;
}
.feedback-received-modal .p {
  color: #ccc;
  /* Body Text */
  font-family: "Open Sans";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin: 0px 0px;
  height: 50px;
}
.button-feedback-received {
  display: flex;
  padding-top: 16px;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  align-self: stretch;
}
.feedbackReceivedModalStyle {
  display: flex;
  width: 100vw !important;
  height: 980px;
  padding: 0px 610px;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  background: rgba(51, 51, 51, 0.6);
}
.feedbackReceivedModalStyle .ant-modal-content {
  background-color: #414855;
  width: 700px;
  height: 256px;
  padding: 40px 40px 40px 40px;
  flex-shrink: 0;
}
.myDataUIMessage {
  display: flex;
  flex-grow: 1;
  align-items: center;
  justify-content: center;
}
.grid-container {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}
.grid-item {
  border: 1px solid #ccc;
  padding: 20px;
  text-align: center;
  flex: 1 1 50px;
}
.list-table {
  width: 100%;
  border-collapse: collapse;
}
.list-table th,
.list-table td {
  padding: 10px;
  text-align: left;
}
.list-table th {
  font-weight: bold;
  border-bottom: 2px solid black;
}
.list-table td:first-child {
  padding: 0 5px 0 10px;
}
.grid-list-button:hover {
  background-color: #A0E2FF !important;
  color: #272931 !important;
}
.grid-list-button.active {
  background-color: #A0E2FF !important;
  color: #272931 !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/ScientiaHeader.less"],"names":[],"mappings":"AAGA;EAEE,aAAA;EACE,YAAA;EAEA,YAAA;EACA,cAAA;EACA,aAAA;EACA,8BAAA;EACA,gCAAA;EACA,mBAAA;EAEA,4HAAA;AALJ;AAPA;EAeM,oBAAA;EAGA,mBAAA;EACA,iBAAA;AAPN;AAZA;EAqBQ,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;AANR;AAnBA;EA6BQ,YAAA;EACA,aAAA;EACA,cAAA;EACA,oBAAA;AAPR;AAzBA;EAqCM,aAAA;EAEA,SAAA;EACA,mBAAA;EACA,oBAAA;AAVN;AA/BA;EA4CQ,aAAA;EACA,yBAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;AAVR;AAtCA;EAoDM,mBAAA;AAXN;AAcE;EACE,aAAA;EACA,wBAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,mBAAA;AAZJ;AAgBE;EACE,mFAAA;AAdJ;AAiBE;EACE,cAAA;EACA,kBAAA;EACA,uDAAA;EACA,wCAAA;EAfF,SAAS;EAkBP,yHAAA;AAhBJ;AAmBE;EACE,cAAA;EACA,eAAA;AAjBJ;AAkBI;EAAA;IACE,aAAA;EAfJ;AACF;AAkBE;EACE,wBAAA;EACA,YAAA;EACA,eAAA;AAhBJ;AAmBE;EACE,wBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;AAjBJ;AAoBA;EACE,aAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;AAlBF;AAUA;EAWI,aAAA;EACA,iBAAA;EACA,uBAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;AAlBJ;AAHA;EAyBI,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,aAAA;EACA,YAAA;EACA,YAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;AAnBJ;AAjBA;EAwCI,aAAA;AApBJ;AApBA;EA4CI,gBAAA;AArBJ;AAvBA;EAgDI,yBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AAtBJ;AA/BA;EAyDI,yBAAA;AAvBJ;AAlCA;EA6DI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;AAxBJ;AAxCA;EAoEI,SAAA;AAzBJ;AA8BA;EACE,aAAA;EACA,uBAAA;EACA,aAAA;EAEA,cAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,iCAAA;EACA,kBAAA;EACA,4HAAA;AA7BF;AAkBA;EAaI,yBAAA;EACA,YAAA;EACA,aAAA;EACA,4BAAA;EACA,gBAAA;EACA,qBAAA;AA5BJ;AAgCA;EACE,iBAAA;AA9BF;AA6BA;EAGI,oCAAA;EACA,YAAA;EACA,8CAAA;EACA,2BAAA;AA7BJ;AA+BI;EACE,kBAAA;EACA,kEAAA;EACA,wCAAA;EA7BJ,SAAS;EA+BL,yHAAA;AA7BN;AAgBA;EAiBI,uBAAA;AA9BJ;AAmCA;EACE,oCAAA;EACA,kBAAA;EACA,kEAAA;EACA,yHAAA;AAjCF;AAoCA;EACE,iDAAA;EAlCA,YAAY;EAoCZ,wBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAlCF;AAqCA;EACE,wBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;AAnCF;AAuCE;EACC,8FAAA;AArCH;AAyCC;EACE,+EAAA;EACA,qBAAA;AAvCH;AA2CC;EACC,UAAA;EACA,sBAAA;AAzCF;AA4CA;EACE,aAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;AA1CF;AAqCA;EAQI,+CAAA;EA1CF,OAAO;EA4CL,wBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;AA1CJ;AA2BA;EAmBI,WAAA;EA3CF,cAAc;EA6CZ,wBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;AA3CJ;AA+CA;EACE,aAAA;EACA,iBAAA;EACA,yBAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;AA7CF;AAgDA;EACE,aAAA;EACA,uBAAA;EACA,aAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,iCAAA;AA9CF;AAsCA;EAUM,yBAAA;EACA,YAAA;EACA,aAAA;EACA,4BAAA;EACA,cAAA;AA7CN;AAiDA;EACE,aAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;AA/CF;AAkDA;EACE,aAAA;EACA,SAAA;EACA,eAAA;AAhDF;AAmDA;EACE,sBAAA;EACA,aAAA;EACA,kBAAA;EACA,cAAA;AAjDF;AAoDA;EACE,WAAA;EACA,yBAAA;AAlDF;AAqDA;;EACE,aAAA;EACA,gBAAA;AAlDF;AAqDA;EACE,iBAAA;EACA,8BAAA;AAnDF;AAsDA;EACE,qBAAA;AApDF;AAwDE;EACE,oCAAA;EACA,yBAAA;AAtDJ;AA0DA;EACE,oCAAA;EACA,yBAAA;AAxDF","sourcesContent":["@import \"../styles/scientia-colors.less\";\n\n\n.Header {\n  // position: fixed;\n  z-index: 1000;\n    width: 100vw;\n    \n    height: 80px;\n    flex-shrink: 0;\n    display: flex;\n    justify-content: space-between;\n    border-bottom: 1px solid @grey-blue;\n    background: @scientia-grey;\n  \n    box-shadow: 0px 8px 10px 0px rgba(0, 0, 0, 0.1),\n      0px 6px 30px 0px rgba(0, 0, 0, 0.06), 0px 16px 24px 0px rgba(0, 0, 0, 0.07);\n    .nav {\n      display: inline-flex;\n      //justify-content: flex-start;\n      //gap: 10px;\n      align-items: center;\n      padding-left: 0px;\n      .logo {\n        margin-right: 40px;\n        width: 145.424px;\n        height: 70px;\n        flex-shrink: 0;\n        margin-left: 7px;\n      }\n      .logo-emsl {\n        // margin-right: 15px;\n        width: 150px;\n        height: 200px;\n        flex-shrink: 0;\n        margin-bottom: -30px;\n      }\n    }\n  \n    .button-group {\n      display: flex;\n      // align-items: flex-start;\n      gap: 16px;\n      align-items: center;\n      padding-right: 100px;\n      \n      .user-name {\n        display: flex;\n        padding: 9px 16px 9px 0px;\n        justify-content: center;\n        align-items: center;\n        gap: 8px;\n      }\n    }\n    .scientia-platform {\n      background: @scientia-dark\n    }\n  }\n  .dropdown {\n    display: flex;\n    padding: 2px 5px 2px 5px;\n    align-items: center;\n    gap: 8px;\n    align-self: stretch;\n    border-radius: 10px;\n  }\n\n  // hover background color for the items of menu\n  .dropdown :hover {\n    background-color: var(--primary-color-hover-low-opacity, rgba(160, 226, 255, 0.15));\n  }\n\n  .dropdown-overlay-style {\n    color: @scientia-blue;\n    border-radius: 4px;\n    border: 2px solid var(--Primary-Color-Default, #66D1FF);\n    background: var(--Surface-0-dp, #2E313A);\n\n    /* 4 dp */\n    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.07), 0px 4px 5px 0px rgba(0, 0, 0, 0.06), 0px 1px 10px 0px rgba(0, 0, 0, 0.10);\n  }\n\n  .hamburger-menu-items {\n    display: block;\n    cursor: pointer;\n    @media screen and (min-width: 1315px) {\n      display: none;\n    }\n  }\n\n  .separator-bar{\n    transform: scale(0.1,1);\n    color: white;\n    font-size: 50px;\n  }\n\n  .modal-text-style {\n    font-family: \"Open Sans\";\n    font-style: normal;\n    line-height: normal;\n    color: #CCCCCC !important;\n    font-weight: 400;\n  }\n\n.content-style {\n  display: flex;\n  width: 600px;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 24px;\n  overflow-y: auto;\n  overflow-x: hidden;\n  max-height: 450px;\n\n  .text-box-style {\n    display: flex;\n    padding: 9px 16px;\n    align-items: flex-start;\n    gap: 8px;\n    flex: 1 0 0;\n    align-self: stretch;\n    width: 565px !important;\n    background-color: @scientia-dark;\n    border-radius: 4px;\n    margin-top: -16px;\n    color: #CCCCCC;\n  }\n\n  .import-files {\n    border-radius: 4px;\n    border: 2px dashed;\n    border-color: @scientia-blue;\n    display: flex;\n    height: 64px;\n    width: 580px;\n    padding: 8px;\n    justify-content: center;\n    align-items: center;\n    gap: 16px;\n    align-self: stretch;\n    margin-top: 8px;\n  }\n\n  .file-input {\n    display: none;\n  }\n\n  .file-list {\n    margin-top: 16px;\n  }\n\n  .delete-button {\n    background-color: #FF4D4F;\n    color: white;\n    border: none;\n    border-radius: 50%; // circle\n    padding: 4px 8px;\n    cursor: pointer;\n  }\n\n  .delete-button :hover {\n    background-color: #ff7875;\n  }\n\n  .file-item {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin-bottom: 8px;\n  }\n\n  .file-item p {\n    margin: 0;\n  }\n\n}\n\n.modalForm {\n  display: flex;\n  width: 100vw !important;\n  height: 980px;\n  // padding: 141px 620px;\n  padding: 100px;\n  justify-content: center;\n  align-items: center;\n  flex-shrink: 0;\n  background: rgba(51, 51, 51, 0.60);\n  border-radius: 4px;\n  box-shadow: 0px 16px 24px 0px rgba(0, 0, 0, 0.07), 0px 6px 30px 0px rgba(0, 0, 0, 0.06), 0px 8px 10px 0px rgba(0, 0, 0, 0.10);\n  .ant-modal-content {\n    background-color: #414855;\n    width: 680px;\n    height: 690px;\n    padding: 40px 40px 32px 40px;\n    overflow-y: auto;\n    display: inline-table;\n  }\n}\n\n.select-feedback-dropdown {\n  margin-top: -16px;\n  .ant-select-selector {\n    background-color: #2E313A !important;\n    color: white;\n    border-color: rgba(51, 51, 51, 0.60) !important;\n    box-shadow: none !important;\n\n    &:hover{\n      border-radius: 4px;\n      border: 2px solid var(--Primary-Color-Default, #66D1FF) !important;\n      background: var(--Surface-0-dp, #2E313A);\n      /* 4 dp */\n      box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.07), 0px 4px 5px 0px rgba(0, 0, 0, 0.06), 0px 1px 10px 0px rgba(0, 0, 0, 0.10);\n    }\n  }\n  .ant-select-arrow {\n    color: white !important;\n  }\n\n}\n\n.dropdown-popup {\n  background-color: #2E313A !important;\n  border-radius: 4px;\n  border: 2px solid var(--Primary-Color-Default, #66D1FF) !important;\n  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.07), 0px 4px 5px 0px rgba(0, 0, 0, 0.06), 0px 1px 10px 0px rgba(0, 0, 0, 0.10);\n}\n\n.select-option-group-text {\n  color: var(--Content-Color-Low-Priority, #BABABA);\n  /* Caption */\n  font-family: \"Open Sans\";\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n\n.select-text-style {\n  font-family: \"Open Sans\";\n  font-style: normal;\n  line-height: normal;\n  color: #CCCCCC ;\n  font-weight: 400;\n}\n\n.ant-select-item {\n  &:hover {\n   background-color: var(--primary-color-hover-low-opacity, rgba(160, 226, 255, 0.15)) !important;\n  }\n }\n \n .ant-select-item-option-selected {\n   background-color: var(--primary-color-active-low-opacity, #66d1ff26) !important;\n   color: red !important;\n   // rgba(102, 209, 255, 0.15)\n }\n\n .ant-select-item-option-active{\n  color: red;\n  background-color: pink;\n }\n\n.feedback-received-modal {\n  display: flex;\n  width: 620px;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 16px;\n\n  .h2 {\n    color: var(--Content-Color-High-Priority, #FFF);\n    /* H2 */\n    font-family: \"Open Sans\";\n    font-size: 32px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: normal;\n    margin: 0px 0px;\n  }\n\n  .p {\n    color: @grey;\n/* Body Text */\n    font-family: \"Open Sans\";\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n    margin: 0px 0px;\n    height: 50px;\n    }\n  }\n\n.button-feedback-received {\n  display: flex;\n  padding-top: 16px;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 8px;\n  align-self: stretch;\n}\n\n.feedbackReceivedModalStyle {\n  display: flex;\n  width: 100vw !important;\n  height: 980px;\n  padding: 0px 610px;\n  justify-content: center;\n  align-items: center;\n  flex-shrink: 0;\n  background: rgba(51, 51, 51, 0.60);\n    .ant-modal-content {\n      background-color: #414855;\n      width: 700px;\n      height: 256px;\n      padding: 40px 40px 40px 40px;\n      flex-shrink: 0;\n    }\n}\n\n.myDataUIMessage {\n  display: flex;\n  flex-grow: 1;\n  align-items: center;\n  justify-content: center;\n}\n\n.grid-container {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.grid-item {\n  border: 1px solid #ccc;\n  padding: 20px;\n  text-align: center;\n  flex: 1 1 50px;\n}\n\n.list-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.list-table th, .list-table td {\n  padding: 10px;\n  text-align: left;\n}\n\n.list-table th {\n  font-weight: bold;\n  border-bottom: 2px solid black;\n}\n\n.list-table td:first-child {\n  padding: 0 5px 0 10px;\n}\n\n.grid-list-button {\n  &:hover{\n    background-color: @scientia-button-hover-blue !important;\n    color: @scientia-dark !important;\n  }\n}\n\n.grid-list-button.active {\n  background-color: @scientia-button-hover-blue !important;\n  color: @scientia-dark !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
